import { createFileRoute } from "@tanstack/react-router"
import { TransactionsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/transactions/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.READ}>
      <TransactionsPage />
    </AuthorizationGate>
  ),
})
